
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import DisplayRuleSet from '@/models/item/stock/specification/display-rule/display-rule-set'
import DisplayNothing from '@/models/item/stock/specification/display-rule/each-case/display-nothing'
import NoDisplayAboutStock from '@/models/item/stock/specification/display-rule/each-case/display-nothing-about-stock'
import DisplayStockIsFew from '@/models/item/stock/specification/display-rule/each-case/display-stock-is-few'
import DisplayStockIsSome from '@/models/item/stock/specification/display-rule/each-case/display-stock-is-some'
import HlWebStockIsSome from '@/models/item/stock/specification/display-rule/each-case/hl-web-stock-is-some'
import SoldOut from '@/models/item/stock/specification/display-rule/each-case/soldout'
import WebStockIsFew from '@/models/item/stock/specification/display-rule/each-case/web-stock-is-few'
import WebStockIsSome from '@/models/item/stock/specification/display-rule/each-case/web-stock-is-some'
import StockIsFew from '@/models/item/stock/specification/stock-is-few'
import GetStockStatus from '../get-stock-status'
/**
 * @see https://my-color.esa.io/posts/459#%E3%83%A2%E3%83%87%E3%83%AB%E5%9B%B3 MCとホテラバの在庫ルールはこちらを参照。
 */
export interface Policy {

  create(): GetStockStatus
}

export class MyColorDefaultPolicy implements Policy {
  static createViaConfig(behaviorConfig: BehaviorConfig): Policy {
    const badgeBehavior = behaviorConfig.itemList.item.badge
    const border = badgeBehavior.few.border

    return new MyColorDefaultPolicy(
      border.onDisplayFew,
      border.onDisplayAmount,
      border.onActual,
      badgeBehavior.soldOut.label
    )
  }

  constructor(
    private readonly borderOfFew: number,
    private readonly borderOfAmount: number,
    private readonly borderOfActual: number,
    private readonly labelOfSoldOut: string
  ) { }

  create() {
    const ruleSet = new DisplayRuleSet([
      new SoldOut(this.labelOfSoldOut),
      new DisplayStockIsFew(
        new StockIsFew(this.borderOfFew).rejectWhenEmpty
      ),
      new DisplayStockIsSome(
        new StockIsFew(this.borderOfAmount).rejectWhenEmpty
      ),
      new WebStockIsFew(
        new StockIsFew(this.borderOfActual)
      ),
      new WebStockIsSome(
        new StockIsFew(this.borderOfActual).rejectWhenEmpty
      ),
      new NoDisplayAboutStock(),
      new DisplayNothing(),
    ])

    return new GetStockStatus(ruleSet)
  }
}

/**
 * ホテラバ用の在庫表示ポリシー
 *
 * 商品一覧で使われるFKUの在庫表示に関して、顧客のやりたいことを実現しているが、
 * 顧客の考えているロジックではなく、元々存在していたMCのロジックをベースにしたもので実装している。
 * 今後、顧客のやりたいことの実現が難しくなった場合、MCのロジックをホテラバのロジックベースにすることも検討の余地あり。
 * @see https://my-color.esa.io/posts/459#ホテラバ仕様
 */
export class HotelLoversPolicy implements Policy {
  static createViaConfig(behaviorConfig: BehaviorConfig): Policy {
    const badgeBehavior = behaviorConfig.itemList.item.badge
    const border = badgeBehavior.few.border

    return new this(
      border.onDisplayFew,
      border.onDisplayAmount,
      border.onActual,
      badgeBehavior.soldOut.label
    )
  }
  constructor(
    private readonly borderOfFew: number,
    private readonly borderOfAmount: number,
    private readonly borderOfActual: number,
    private readonly labelOfSoldOut: string
  ) {}

  create() {
    const ruleSet = new DisplayRuleSet([
      new SoldOut(this.labelOfSoldOut),
      new HlWebStockIsSome(
        new StockIsFew(this.borderOfActual).rejectWhenEmpty
      ),
      new DisplayStockIsFew(
        new StockIsFew(this.borderOfFew)
      ),
      new DisplayStockIsSome(
        // 調整在庫が「30」以下「7」以上(「6」以下「1」以上は1つ前のルールに適合する)
        new StockIsFew(this.borderOfAmount).rejectWhenEmpty
      ),
      new NoDisplayAboutStock(),
      new DisplayNothing(),
    ])

    return new GetStockStatus(ruleSet)
  }
}
